import { createBrowserHistory } from 'history';
import { BASE_ROUTE } from './constants';

export default createBrowserHistory({ basename: BASE_ROUTE });
